module.exports = __webpack_public_path__ + "img/05010012.e5fc9b03.jpg";